module.exports = __webpack_public_path__ + "img/349-c07b2e.png";